import type {Sentence} from "$lib/classes/data/sentence";
import type {SentenceId} from "$lib/classes/data/_primitives";

export function moveSentenceToBeginning(sentences: Sentence[], sentenceId: SentenceId) {

    const index = sentences.findIndex(sentence => sentence.id === sentenceId)
    if (index === -1) {
        console.error('ERROR moveSentenceToBeginning() - no sentence with provided Id found!')
    }

    const sentenceToMove = sentences[index]

    return [sentenceToMove, ...sentences.slice(0, index), ...sentences.slice(index + 1)]
}